module.exports = __webpack_public_path__ + "static/media/stockhausen_held_13.1628887b.png";